
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work-management/documents/[document]",
      function () {
        return require("private-next-pages/work-management/documents/[document].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work-management/documents/[document]"])
      });
    }
  